import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import history from '../utils/history';
import { checkIfHotjarEnable, timeBetweenDates } from '../utils/helpers';
import * as sinisterCardsActions from '../redux/actions/sinister-cards';
import InfoCard from '../components/content/InfoCard/InfoCard';
import RimacTopBar from '../components/common/RimacTopBar/RimacTopBar';
import Navbar from '../components/common/Navbar/Navbar';
import IconWarning from '../assets/ic_warning.svg';
import ModalFinal from '../assets/modalFinal.svg';

const infoProps = {
  adIcon: IconWarning,
  textAd:
    'Recuerda estar atento a tu correo electrónico, un asesor de Rimac se comunicará contigo para verificar esta información.',
  firstQuestion:
    '¿Tienes contratado otro seguro de Protección de Tarjetas con otra Entidad Bancaria o Aseguradora?',
  secondQuestion: '¿Has solicitado la cobertura para este mismo siniestro?',
  modalIcon: ModalFinal,
  modalText:
    'Al hacer clic en el botón enviar confirmas que la información provista es cierta y tiene carácter de declaración jurada.',
  modalTitle: 'Datos declarados en el formulario',
};

const InsuranceInfoPage = () => {
  const dispatch = useDispatch();
  const otherInsuranceStatus = useSelector(
    (state) => state.sinisterCards.otherInsurance
  );
  const [first, setFirst] = useState(otherInsuranceStatus.otherInsurance);
  const [sec, setSec] = useState(otherInsuranceStatus.coverage);
  const [viewStartTime, setViewStartTime] = useState(new Date());

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    return () => {
      const endTime = new Date();
      const userTotalTime = timeBetweenDates(viewStartTime, endTime);

      if (checkIfHotjarEnable()) {
        window.digitalData.push({
          task: {
            name: 'Tiempo registrado - Otros seguros',
            time: userTotalTime,
          },
          event: 'trackTimeToComplete',
        });
      }
    };
  }, []);

  const handleFirst = (e) => {
    setFirst(e.target.value);
  };

  const handleSec = (e) => {
    setSec(e.target.value);
  };

  const validateForm = () => {
    return !(first === 'no' || (first === 'si' && sec));
  };

  const onBackHandler = () => {
    history.replace('/detalle-siniestro');
  };

  const onContinueHandler = () => {
    dispatch(
      sinisterCardsActions.setOtherInsurance({
        otherInsurance: first,
        coverage: sec,
      })
    );
    history.replace('/antes-de-comenzar');
  };

  return (
    <>
      <RimacTopBar />
      <div
        data-testid="insurance-info-page"
        className="insuranceInfoPage pageContainer"
      >
        <div className="insuranceInfoPage__left pageContainer__left">
          <div className="titleCont">
            <h1 className="u-mb-24">Seguro de Protección de Tarjetas</h1>
            <p>
              Hola, sabemos que sufriste un siniestro y queremos ayudarte a
              reportarlo.
            </p>
          </div>
        </div>
        <div className="insuranceInfoPage__right pageContainer__right">
          <div>
            <p className="other-insurance__question">
              {infoProps.firstQuestion}
            </p>
            <div className="other-insurance__answer">
              <label className="container">
                Si
                <input
                  type="radio"
                  name="firstQuestion"
                  onChange={handleFirst}
                  value="si"
                  checked={first === 'si'}
                />
                <span className="checkmark"></span>
              </label>
              <label className="container">
                No
                <input
                  type="radio"
                  name="firstQuestion"
                  onChange={handleFirst}
                  value="no"
                  checked={first === 'no'}
                />
                <span className="checkmark"></span>
              </label>
            </div>
          </div>

          {first === 'si' && (
            <>
              <p className="other-insurance__question">
                {infoProps.secondQuestion}
              </p>
              <div className="other-insurance__answer">
                <label className="container">
                  Si
                  <input
                    type="radio"
                    name="secondQuestion"
                    onChange={handleSec}
                    value="si"
                    checked={sec === 'si'}
                  />
                  <span className="checkmark"></span>
                </label>
                <label className="container">
                  No
                  <input
                    type="radio"
                    name="secondQuestion"
                    onChange={handleSec}
                    value="no"
                    checked={sec === 'no'}
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
              {sec === 'si' && (
                <InfoCard icon={IconWarning} content={infoProps.textAd} />
              )}
            </>
          )}
        </div>

        <Navbar
          navActive
          onBackClick={onBackHandler}
          onContinueClick={onContinueHandler}
          isNextDisabled={validateForm()}
          currentStep={1}
          totalSteps={5}
          stepperText={'VOLVER'}
        />

        <div className="spacingLeft"></div>
      </div>
    </>
  );
};

export default InsuranceInfoPage;
